module.exports = __webpack_public_path__ + "a57d26c13852e363964b92c1d8bbfdec.svg";